/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigDisplayBatteryManagement_ConfigFragment = { __typename: 'ConfigurationModel', id: string, battery?: { __typename: 'ConfigBatteryState', reported: { __typename: 'ConfigBattery', powerManagement: string } } | null };

export type ConfigUpdateBatteryPowerManagementMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateBatteryPowerManagementInput;
}>;


export type ConfigUpdateBatteryPowerManagementMutation = { __typename: 'Mutation', configurationUpdateBatteryPowerManagement: { __typename: 'ConfigurationModel', id: string, battery?: { __typename: 'ConfigBatteryState', reported: { __typename: 'ConfigBattery', powerManagement: string } } | null } };

export const ConfigDisplayBatteryManagement_ConfigFragmentDoc = gql`
    fragment ConfigDisplayBatteryManagement_config on ConfigurationModel {
  id
  battery {
    reported {
      powerManagement
    }
  }
}
    `;
export const ConfigUpdateBatteryPowerManagementDocument = gql`
    mutation ConfigUpdateBatteryPowerManagement($input: ConfigurationUpdateBatteryPowerManagementInput!) {
  configurationUpdateBatteryPowerManagement(input: $input) {
    id
    ...ConfigDisplayBatteryManagement_config
  }
}
    ${ConfigDisplayBatteryManagement_ConfigFragmentDoc}`;
export type ConfigUpdateBatteryPowerManagementMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateBatteryPowerManagementMutation, ConfigUpdateBatteryPowerManagementMutationVariables>;

/**
 * __useConfigUpdateBatteryPowerManagementMutation__
 *
 * To run a mutation, you first call `useConfigUpdateBatteryPowerManagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateBatteryPowerManagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateBatteryPowerManagementMutation, { data, loading, error }] = useConfigUpdateBatteryPowerManagementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateBatteryPowerManagementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateBatteryPowerManagementMutation, ConfigUpdateBatteryPowerManagementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateBatteryPowerManagementMutation, ConfigUpdateBatteryPowerManagementMutationVariables>(ConfigUpdateBatteryPowerManagementDocument, options);
      }
export type ConfigUpdateBatteryPowerManagementMutationHookResult = ReturnType<typeof useConfigUpdateBatteryPowerManagementMutation>;
export type ConfigUpdateBatteryPowerManagementMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateBatteryPowerManagementMutation>;
export type ConfigUpdateBatteryPowerManagementMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateBatteryPowerManagementMutation, ConfigUpdateBatteryPowerManagementMutationVariables>;